import classnames from 'classnames';

import Link from '@/components/renderers/Link';
import Pill from '@/components/Pill';

export default function Bullet({
  content,
  colour = 'PURPLE',
  endTime,
  startTime,
  type,
  url,
}) {
  if (new Date() > new Date(endTime) || new Date() < new Date(startTime)) {
    return null;
  }

  const textColourClass = (colourParam) => {
    switch (colourParam) {
      case 'BLACK':
        return 'text-haiti';
      case 'DARK_BLUE':
        return 'text-zodiac';
      case 'PINK':
        return 'text-rose';
      case 'PURPLE':
      default:
        return 'text-cornflower';
    }
  };

  const bulletClass = classnames(
    '-mb-6 -ml-1 flex group items-baseline rounded-sm',
    textColourClass(colour),
  );

  return (
    <Link href={url} className={bulletClass}>
      <Pill label={type} colour={colour} />
      <p className="font-semibold leading-relaxed text-sm">
        {content}
        <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
          &#8594;
        </span>
      </p>
    </Link>
  );
}
